<template>
  <div class="mycontainer">
    <div class="headerclass">科创资讯</div>
    <div class="tableclass">
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          v-for="(item,index) in tabnamelist"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          width="180">
        </el-table-column>

      </el-table>
    </div>

  </div>

</template>

<script>
  import * as api from "../../utils/api"
  import axios from "axios";


  export default {
    components: {

    },
    name: "home",
    data(){
      return{
        tabnamelist:[{prop:'name',label:'姓名'},{prop:'date',label:'日期'},{prop:'address',label:'地址'}],
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }]
      }
    },
    mounted(){

    },
    methods:{



    }
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
  .mycontainer{
    background: #fff;
    width: 100%;
    min-height: calc(100vh - 70px);
    .headerclass{
      padding: 20px 0;
      margin: 0 20px;
      height: 15px;
      font-size: 16px;
      color: #2a3138;
      border-bottom: 1px solid #e6eaf0;
      .tableclass{
        padding: 20px;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/views/collection/annalsCollection.vue